import { render, staticRenderFns } from "./DimensionBoostAutobuyerBox.vue?vue&type=template&id=b44dddb8&scoped=true&"
import script from "./DimensionBoostAutobuyerBox.vue?vue&type=script&lang=js&"
export * from "./DimensionBoostAutobuyerBox.vue?vue&type=script&lang=js&"
import style0 from "./DimensionBoostAutobuyerBox.vue?vue&type=style&index=0&id=b44dddb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44dddb8",
  null
  
)

export default component.exports